module.exports = __webpack_public_path__ + "static/media/wepik-export-20230604062102jrbO.aa261b00.jpeg";